export const facilitatorSiteCoreKeys = {
  facilitator: "Projects.CreateNewProject.Facilitator",
  facilitatorAssignedDate: "CreateNewProject.Facilitator.AssignedDate",
  facilitatorAddFunction: "CreateNewProject.Facilitator.AddFunction",
  facilitatorFunctionDropDownLabel:
    "CreateNewProject.Facilitator.FunctionDropDownLabel",
  facilitatorLabel: "CreateNewProject.Facilitator.Facilitator",
  facilitatorFunctionTableColumn:
    "CreateNewProject.Facilitator.FunctionTableColumn",
  facilitatorTableColumn: "CreateNewProject.Facilitator.FacilitatorTableColumn",
  facilitatorAssignedDateTableColumn:
    "CreateNewProject.Facilitator.AssignedDateTableColumn",
  facilitatorActionTableColumn:
    "CreateNewProject.Facilitator.ActionTableColumn",
  facilitatorDeleteConfirm:
    "CreateNewProject.Facilitator.AreYouSureYouWantToDeleteThisAssignment",
  functionDropdownValue: "CreateNewProject.Facilitator.FunctionList",
  facilitatorAlreadyAssigned:
    "CreateNewProject.Facilitator.FacilitatorAlreadyAssigned",
};
